import users from '@services/users'
import { inject, observer } from 'mobx-react'
import { Button, Card, Input, Layout, Modal, Select, PageHeader, Pagination, Table, Tooltip, Icon } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import React from 'react'
import { alertPopup } from '@utils/popup'

const DR_HOME_ORDER_LIMIT = 3

class SmallClientList extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            searchBy: 'identity',
            searchValue: '',
            page: 1,
            perPage: 10,
            lastPage: 1000,
            byId: false,
            orderingUserId: null // tracks which row has an in-flight order request
        }
    }

    componentDidMount() {
        this.getClients()
    }

    getClients = (modal?: any) => {
        const { searchBy, searchValue, page, perPage, byId } = this.state
        if (searchBy && searchValue) {
            let response
            users
                .getSmallClientList({ searchBy, searchValue, page, perPage })
                .then(res => {
                    response = res
                    if (res.data.data.length === 0)
                        alertPopup({
                            type: 'error',
                            title: 'לא נמצא לקוח',
                            body: 'לא נמצא לקוח עם הפרטים שהוזנו / הלקוח ללא מינוי'
                        })
                    else {
                        if (!res.data.data[0].product_name && !res.data.data[0].is_app_user)
                            alertPopup({ type: 'error', title: 'שימו לב!', body: 'בן המשפחה אינו כלול במינוי' })
                    }
                    this.setState({ list: res.data.data, lastPage: res.data.lastPage, orderingUserId: null }, () => {
                        if (modal) {
                            modal.update({
                                icon: null,
                                title: null,
                                content: (
                                    <div style={{ textAlign: 'center', padding: '16px 0' }}>
                                        <div style={{ fontSize: '40px', color: '#52c41a', lineHeight: 1 }}>{'✓'}</div>
                                        <div style={{ fontSize: '18px', fontWeight: 600, marginTop: '8px' }}>
                                            {'הוזמן בהצלחה'}
                                        </div>
                                    </div>
                                ),
                                okText: 'סגור',
                                okButtonProps: { loading: false, disabled: false },
                                cancelButtonProps: { style: { display: 'none' } },
                                onOk: () => modal.destroy()
                            })
                        }
                    })
                })
                .catch(error => {
                    console.log('error', error)
                })
                .finally(() => {
                    if (byId) {
                        let searchValue = ''
                        if (response.data.data.length > 0) searchValue = response.data.data[0].identity
                        this.setState({ searchBy: 'identity', searchValue: searchValue, byId: false })
                    }
                })
        }
    }

    handleInput = e => {
        this.setState({ searchValue: e.target.value })
    }

    enterClick = e => {
        if (e.key === 'Enter') {
            this.getClients()
        }
    }

    resetAllFilters = () => {
        this.setState({ searchBy: 'identity', searchValue: '', list: [], lastPage: 1000 }, () => this.getClients())
    }

    prevPage = () => {
        const { page } = this.state
        if (page > 1) this.setState({ page: page - 1 }, () => this.getClients())
    }

    nextPage = () => {
        const { page, lastPage } = this.state
        if (page < lastPage) this.setState({ page: page + 1 }, () => this.getClients())
    }

    setPerPage = value => {
        this.setState({ perPage: value, page: 1 }, () => this.getClients())
    }

    goToClient = id => {
        this.setState({ searchBy: 'id', searchValue: id, byId: true }, () => this.getClients())
    }

    orderDrHome = (record, modal) => {
        this.setState({ orderingUserId: record.phone })
        if (modal) {
            modal.update({
                content: <span>{'טוען...'}</span>,
                okButtonProps: { loading: true, disabled: true },
                cancelButtonProps: { disabled: true }
            })
        }
        const createdBy = this.props.authStore ? this.props.authStore.fullName : ''
        users
            .createDrHomeOrder({ phone: record.phone, created_by: createdBy })
            .then(() => {
                this.getClients(modal)
            })
            .catch(() => {
                if (modal) modal.destroy()
                alertPopup({ type: 'error', title: 'שגיאה', body: 'ההזמנה נכשלה, נסה שוב' })
                this.setState({ orderingUserId: null })
            })
    }

    columns: ColumnProps<any>[] = [
        {
            title: 'שם',
            key: 'name',
            align: 'right',
            render: (_, record) => `${record.first_name} ${record.last_name}`
        },
        {
            title: 'ת.ז / דרכון',
            key: 'identity',
            align: 'right',
            render: (_, record) => record.identity || record.passport
        },
        {
            title: 'טלפון',
            key: 'phone',
            align: 'right',
            render: (_, record) => {
                if (!record.phone) return ''
                const phone = `${record.phone}`
                return phone.startsWith('0') ? phone : `0${phone}`
            }
        },
        {
            title: 'מינוי',
            key: 'product',
            align: 'right',
            // show sub only when malram_relevant_product=true (relevant product); hide for irrelevant sub (C1b, C2b)
            render: (_, record) => (record.malram_relevant_product ? record.product_name : '')
        },
        //    {
        //     title: "סטאטוס מינוי",
        //     key: 'subscription_status',
        //     align: 'right',
        //     render: (_, record) => statuses[record.subscription_status] || ''
        //    },

        {
            title: 'שיוך משפחתי',
            key: 'related_as',
            align: 'right',
            render: (_, record) => {
                if (record.parent_id) {
                    return (
                        <span>
                            {'משוייך ל '}
                            <span style={{ ...styles.link }} onClick={() => this.goToClient(record.parent_id)}>
                                {`${record.parent_first_name} ${record.parent_last_name} `}
                            </span>
                            {'כ'}
                            {`${relations[record.related_as] || ''}`}
                        </span>
                    )
                }
            }
        },
        {
            title: 'משתמש אפליקציה',
            key: 'app_user',
            align: 'right',
            render: (_, record) => {
                const isApp = !!record.app_user_id
                return (
                    <span
                        style={{
                            display: 'inline-block',
                            padding: '2px 10px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 600,
                            background: isApp ? '#389e0d' : '#fff1f0',
                            color: isApp ? '#fff' : '#ff4d4f',
                            border: `1px solid ${isApp ? '#237804' : '#ffa39e'}`
                        }}
                    >
                        {isApp ? '✓ כן' : '✗ לא'}
                    </span>
                )
            }
        },
        {
            title: 'שימושים',
            key: 'orders_used_col',
            align: 'right',
            render: (_, record) => {
                if (!record.app_user_id) return '—'
                if (record.malram_relevant_product) return '—'
                const used = record.orders_used || 0
                const limit = DR_HOME_ORDER_LIMIT
                const pct = Math.min((used / limit) * 100, 100)
                return (
                    <div style={{ minWidth: '80px' }}>
                        <div
                            style={{ fontSize: '11px', color: '#666', textAlign: 'right', marginBottom: '3px' }}
                        >{`${used} / ${limit}`}</div>
                        <div style={{ background: '#f0f0f0', borderRadius: '4px', height: '6px', overflow: 'hidden' }}>
                            <div
                                style={{
                                    width: `${pct}%`,
                                    height: '100%',
                                    background: '#389e0d',
                                    borderRadius: '4px',
                                    transition: 'width 0.3s'
                                }}
                            />
                        </div>
                    </div>
                )
            }
        },
        {
            title: 'הזמן רופא',
            key: 'order_doctor_col',
            align: 'right',
            width: 220,
            render: (_, record) => {
                if (!record.app_user_id) return ''
                if (record.malram_relevant_product) return ''
                const used = record.orders_used || 0
                const limit = DR_HOME_ORDER_LIMIT
                if (used >= limit) {
                    let nextDate = ''
                    if (record.orders_window_end) {
                        const d = new Date(record.orders_window_end)
                        const dd = String(d.getDate()).padStart(2, '0')
                        const mm = String(d.getMonth() + 1).padStart(2, '0')
                        const yyyy = d.getFullYear()
                        nextDate = dd + '/' + mm + '/' + yyyy
                    }
                    return (
                        <div style={{ fontSize: '12px', color: '#ff4d4f', lineHeight: '1.5', textAlign: 'right' }}>
                            <strong style={{ display: 'block' }}>{'המכסה נוצלה'}</strong>
                            {nextDate ? `יתחדש ב־${nextDate}` : ''}
                        </div>
                    )
                }
                const today = new Date().toLocaleDateString('en-CA') // YYYY-MM-DD in local time
                const lastDateStr = record.last_order_date
                    ? new Date(record.last_order_date).toLocaleDateString('en-CA')
                    : null
                const orderedToday = lastDateStr === today

                return (
                    <Tooltip title={orderedToday ? <span>{'ניתן להזמין רופא פעם ביום'}</span> : null}>
                        <span>
                            <Button
                                size="small"
                                type="primary"
                                disabled={this.state.orderingUserId !== null || !!orderedToday}
                                onClick={() => {
                                    const modal = Modal.confirm({
                                        icon: null,
                                        title: 'הזמנת רופא',
                                        content: `האם להזמין רופא עבור ${record.first_name} ${record.last_name}?`,
                                        okText: 'אישור',
                                        cancelText: 'ביטול',
                                        // never-resolving Promise so antd won't auto-close; destroy() on error and update() on success handle closing
                                        onOk: () =>
                                            new Promise(() => {
                                                this.orderDrHome(record, modal)
                                            })
                                    })
                                }}
                                style={
                                    orderedToday
                                        ? {
                                              background: '#d9d9d9',
                                              borderColor: '#d9d9d9',
                                              color: '#999',
                                              whiteSpace: 'nowrap'
                                          }
                                        : { background: '#00b87a', borderColor: '#00b87a', whiteSpace: 'nowrap' }
                                }
                            >
                                <Icon type={this.state.orderingUserId === record.phone ? 'loading' : 'medicine-box'} />
                                <span style={{ marginLeft: '4px' }}>{'הזמן רופא'}</span>
                            </Button>
                        </span>
                    </Tooltip>
                )
            }
        },
        {
            title: 'משפחה',
            key: 'family',
            align: 'right',
            render: (_, record) => {
                try {
                    if (!record.family) return ''
                    const familyArray = JSON.parse(record.family)
                    if (Array.isArray(familyArray) && familyArray.length > 0) {
                        const familyNames = familyArray.map(member => (
                            <span key={member.id} style={{ ...styles.link }} onClick={() => this.goToClient(member.id)}>
                                {`${member.first_name} ${member.last_name}`}
                            </span>
                        ))
                        return (
                            <div style={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
                                {familyNames.reduce((prev, curr) => [prev, ', ', curr])}
                            </div>
                        )
                    } else {
                        return ''
                    }
                } catch (error) {
                    // Handle the error if JSON parsing fails
                    console.error('Error parsing family array:', error)
                    console.log('record.family:', record.family)
                    return ''
                }
            }
        }
    ]

    render() {
        const { list, page, perPage, lastPage, searchBy, searchValue } = this.state
        return (
            <Layout>
                <PageHeader backIcon={null} title="לקוחות"></PageHeader>
                <Card
                    title={
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'stretch' }}>
                                <div style={{ display: 'flex', alignItems: 'stretch' }}>
                                    <span style={{ lineHeight: '1.8', marginLeft: '30px' }}>{'חיפוש לפי:'}</span>
                                    <Select
                                        id="type"
                                        style={{ width: '150px' }}
                                        defaultValue={this.state.searchBy}
                                        value={this.state.searchBy}
                                        onChange={value => this.setState({ searchBy: value, searchValue: '' })}
                                    >
                                        <Select.Option value={'identity'}>{'ת״ז'}</Select.Option>
                                        <Select.Option value={'passport'}>{'דרכון'}</Select.Option>
                                        <Select.Option value={'phone'}>{'טלפון'}</Select.Option>
                                    </Select>
                                </div>
                                <Input
                                    value={this.state.searchValue}
                                    onChange={this.handleInput}
                                    onKeyDown={this.enterClick}
                                />
                                <Button onClick={() => this.getClients()}>חיפוש</Button>
                                <Button style={{ marginRight: '30px' }} onClick={this.resetAllFilters}>
                                    {'איפוס'}
                                </Button>
                            </div>

                            {/* <div style={{ display: 'flex' }}>
                                <span>{"פריטים בעמוד"}</span>
                                <div>

                                    <Select
                                        id="type"
                                        style={{ width: '110px' }}
                                        defaultValue={perPage}
                                        value={perPage}
                                        onChange={this.setPerPage}
                                        >
                                        <Select.Option value={10}>{10}</Select.Option>
                                        <Select.Option value={20}>{20}</Select.Option>
                                        <Select.Option value={50}>{50}</Select.Option>
                                        <Select.Option value={100}>{100}</Select.Option>
                                        <Select.Option value={1000}>{1000}</Select.Option>
                                    </Select>
                                </div>

                                <div>
                                    <Button style={{ ...styles.pageButton }} onClick={this.nextPage}>{"<"}</Button>
                                        <span style={{ ...styles.pageNumber }}>{page}</span>
                                    <Button style={{ ...styles.pageButton }} onClick={this.prevPage}>{">"}</Button>
                                </div>
                            </div> */}
                        </div>
                    }
                    headStyle={{ backgroundColor: '#dadce0' }}
                    bodyStyle={{ padding: '0.8rem 0.8rem' }}
                    style={{ marginBottom: '1rem' }}
                >
                    <Table
                        columns={this.columns}
                        dataSource={list}
                        pagination={false}
                        rowKey={(record: any) => record.id || record.phone}
                    />

                    {/* 
                    {list.map((item, idx) => {
                        return (
                            <div key={idx.toString()} style={{ ...styles.row }} >
                                <div style={{ ...styles.cell }}>
                                    {item.id}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {`${item.first_name} ${item.last_name}`}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {item.identity || item.passport}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {item.phone}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {item.product_name}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {item.subscription_status}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {item.family}
                                </div>
                                <div style={{ ...styles.cell }}>
                                    {item.parent_id ?
                                    <span>
                                        {"משוייך ל "}
                                        <span
                                            style={{ ...styles.link }}
                                            onClick={() => this.goToClient(item.parent_id)}
                                        >
                                                {`${item.parent_first_name} ${item.parent_last_name} `}
                                        </span>
                                        {"כ"}
                                        {`${relations[item.related_as] || ''}`}
                                    </span> : ''}
                                </div>
                            </div>
                        )
                    })} */}
                </Card>
            </Layout>
        )
    }
}

const relations = {
    PARTNER: 'בן/ת זוג',
    CHILD: 'ילד/ה'
}

const statuses = {
    ACTIVE: 'פעיל',
    BLOCKED: 'חסום'
}

const styles = {
    row: { display: 'flex' },
    cell: { padding: '10px 20px' },
    pageButton: { padding: '0', margin: '0 16px', height: '24px', width: '24px' },
    pageNumber: {
        display: 'inline-block',
        width: '24px',
        height: '26px',
        background: 'white',
        textAlign: 'center',
        borderRadius: '4px'
    },
    link: { cursor: 'pointer', color: '#e77910' }
}

export default inject('authStore')(observer(SmallClientList))
